/* unplugin-vue-components disabled */import script from "./BaseImg.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseImg.vue?vue&type=script&setup=true&lang=js"

import "./BaseImg.vue?vue&type=style&index=0&id=3c5052cd&lang=scss"

export default script